import React, {Component} from 'react';
import '../../App.css';
import ContactContent from '../ContactContent';

    function Contact() {
        return (
          <>
              <ContactContent />
          </>
        )
      }
    
    export default Contact;